import React from 'react';
import PropTypes from 'prop-types';

import { Label } from 'semantic-ui-react';

const INVITATION_STATUS = {
  deferred: 'DEFERRED',
  sent: 'SENT',
  accepted: 'ACCEPTED',
};

const InvitationStatus = ({ status }) => {
  if (status === INVITATION_STATUS.accepted) {
    return (
      <Label size="large" basic color="blue" content="JOINED" />
    );
  }

  if (status === INVITATION_STATUS.sent) {
    return (
      <Label size="large" basic content="INVITED" color="orange" />
    );
  }

  return (
    <Label size="large" basic content="NOT INVITED" color="grey" />
  );
};

InvitationStatus.propTypes = {
  status: PropTypes.string.isRequired,
};

export default InvitationStatus;



/** WEBPACK FOOTER **
 ** ./src/components/invitation-status/index.js
 **/